module.exports = __webpack_public_path__ + "img/coinapp-setting-step-four.ebd9cd02.png";